import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {AbstractCrudService} from '../shared/abstract-crud.service';
import {Linking} from './linking.model';

/**
 * Service for interacting with Linkings.
 */
@Injectable()
export class LinkingCrudService extends AbstractCrudService<Linking> {
  /**
   * URL for current model, override url from superclass
   * @type {string}
   */
  protected url = environment.regoApiURL + 'linkings';

  private linkings: Promise<Linking[]>;

  /**
   * Default constructor
   * @param {HttpClient} http - refined http service, automatically adds authentication token
   */
  constructor(protected http: HttpClient) {
    super(http);

    this.linkings = new Promise((resolve, reject) => {
      this.list().then(result => {
        resolve(result.data);
      }, reject);
    });
  }

  /**
   * find source system identifier that is linked to rego identifier.
   * if source system is not given, by default try to find rego id's linked to misonet
   * @param regoId
   * @param sourceSystem
   */
  public async getSourceIdForRegoId(regoId: string, sourceSystem: string = 'misonet'): Promise<Linking> {
    try {
      return (await this.linkings).find(o => {
        return o.regoId + '' + o.sourceSystem === regoId + '' + sourceSystem;
      });
    } catch (e) {
      return null;
    }
  }

  public async getRegoIdForSourceId(sourceId: string): Promise<string> {
    try {
      return (await this.linkings).find(o => {
        return o.sourceId + '' === sourceId + '';
      }).regoId;
    } catch (e) {
      return null;
    }
  }

}
